class SoundContentData {
  constructor(category, sound) {
    this.category = category;
    this.sound = sound;
  }
  category;
  sound;
}

export { SoundContentData };
//# sourceMappingURL=data.js.map
